import { IntegrationSystem } from "../../types";
import { ShopwerkConnectView } from "./ConnectView";
import { ShopwerkSettingsView } from "./SettingsView";

export const ShopwerkSystem: IntegrationSystem = {
  ConnectView: ShopwerkConnectView,
  SettingsView: ShopwerkSettingsView
};

export { shopwerkIntegrationReducer } from "./redux";
